const VeganSVG = ({ color, iconSize=24 }) => (
    <svg width={iconSize} height={iconSize} viewBox="0 1 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.6368 17.1176H14.9948V6.69312H20.6368M12.2778 6.94957L7.32899 17.1176H7.27354L2.32471 6.94957M19.7912 11.9053H14.9948" stroke={`${color}`} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default VeganSVG;